import { z } from "zod";
import { TObjectBase } from "../base";
import { TRelatives } from "../common/relative";
import { TReadAccess } from "../common/readAccess";

export const TRawChecklistTemplateTask = z.object({
  title: z.string(),
  description: z.string().optional(),
  responsible: z.record(z.object({})).optional(),

  fields: z
    .record(
      z.object({
        title: z.string(),
        value: z.string().optional(),
        valueType: z.string().optional(),
        unit: z.string().optional(),
        options: z.array(z.string()).optional(),
      })
    )
    .optional(),
  fieldsOrder: z.array(z.string()).optional(),

  relatives: TRelatives.optional(),
});
export type IRawChecklistTemplateTask = z.infer<
  typeof TRawChecklistTemplateTask
>;

/**
 * @deprecated  Use IRawChecklistTemplate instead
 */
export type IChecklistTemplate = z.infer<typeof TChecklistTemplate>;

/**
 * @deprecated  Use TRawChecklistTemplate instead
 */
export const TChecklistTemplate = z
  .object({
    title: z.string(),

    taskOrder: z.array(z.string()),
    tasks: z.record(TRawChecklistTemplateTask),
  })
  .extend(TObjectBase.shape);

/**
 * @deprecated Use array of TRawChecklistTemplate instead
 *  */
export const TChecklistTemplates = z.array(TChecklistTemplate);

/**
 * @deprecated Use IRawChecklistTemplate instead
 */
export type IChecklistTemplates = z.infer<typeof TChecklistTemplates>;

export const TRawChecklistTemplate = z
  .object({
    title: z.string(),
    taskOrder: z.array(z.string()),
    tasks: z.record(TRawChecklistTemplateTask),
    readAccess: TReadAccess.optional(),
  })
  .extend(TObjectBase.shape);
export type IRawChecklistTemplate = z.infer<typeof TRawChecklistTemplate>;
